// ABOUTME: The current user as the job permission helpers see it: username and the job-relevant
// ABOUTME: roles, read from the auth context (hasUserRole), plus the superadmin shortcut.

import { useAuth } from '@src/hooks';
import { useMemo } from 'react';

import { JOB_ADMIN_ROLES, JobActor, SUPERADMIN_ROLE } from '../../utils/jobPermissions';

export function useJobActor(): JobActor & { isSuperAdmin: boolean } {
    const { hasUserRole, sessionData } = useAuth();
    const username = sessionData?.username ?? null;
    // The roles are re-read on every render: their joined form keeps the memo stable.
    const rolesKey = JOB_ADMIN_ROLES.filter(role => hasUserRole(role)).join(',');
    return useMemo(() => {
        const roles = rolesKey ? rolesKey.split(',') : [];
        return { username, roles, isSuperAdmin: roles.includes(SUPERADMIN_ROLE) };
    }, [username, rolesKey]);
}
